import { defineComponent as $, computed as r, createElementBlock as b, openBlock as m, mergeProps as N, unref as l, createCommentVNode as c, createBlock as O, createVNode as F, renderSlot as k, normalizeClass as E, createElementVNode as I, createTextVNode as L, toDisplayString as g } from "vue";
import s from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Pagination/pagination.js";
import G from "./PaginationOptionsMenu.vue2.js";
import M from "./PaginationNavigation.vue2.js";
import { defaultPerPageOptions as y } from "./common.js";
import { classesFromBreakpointProps as T } from "../../breakpoints.js";
import { isDefined as P } from "../../node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import { useOUIAProps as U } from "../../helpers/ouia.js";
const V = ["id"], Q = /* @__PURE__ */ $({
  name: "PfPagination",
  __name: "Pagination",
  props: {
    variant: {},
    static: { type: Boolean },
    compact: { type: Boolean },
    sticky: { type: Boolean },
    count: { default: 0 },
    firstPage: { default: 1 },
    offset: {},
    itemsStart: {},
    itemsEnd: {},
    titleItems: {},
    titlePage: {},
    titlePages: {},
    titleItemsPerPage: { default: "Items per page" },
    titlePerPageSuffix: { default: "per page" },
    toFirstPageAriaLabel: { default: "Go to first page" },
    toPreviousPageAriaLabel: { default: "Go to previous page" },
    toLastPageAriaLabel: { default: "Go to last page" },
    toNextPageAriaLabel: { default: "Go to next page" },
    titleOptionsToggle: { default: "" },
    currPageAriaLabel: { default: "Current page" },
    paginationAriaLabel: { default: "Pagination" },
    ouiaId: {},
    ouiaSafe: { type: Boolean },
    lastFullPageShown: { type: Boolean },
    disabled: { type: Boolean },
    dropUp: { type: Boolean },
    page: { default: 1 },
    perPage: { default: y[0].value },
    perPageOptions: { default: () => [...y] },
    widgetId: { default: "options-menu" },
    inset: {},
    insetSm: {},
    insetMd: {},
    insetLg: {},
    insetXl: {},
    inset2xl: {}
  },
  emits: ["update:page", "update:perPage", "first-click", "previous-click", "next-click", "last-click"],
  setup(A, { emit: S }) {
    const a = A, B = U({ id: a.ouiaId, safe: a.ouiaSafe }), o = S, w = T(a, ["inset"], s), u = r(() => a.count <= 0 ? 0 : (p.value - 1) * a.perPage + 1), f = r(() => a.count <= 0 ? 0 : p.value === n.value ? a.count : p.value * a.perPage), n = r(() => Math.ceil(a.count / a.perPage) || 0), d = r(() => P(a.offset) ? a.offset + 1 : a.itemsStart), C = r(() => P(a.offset) ? a.offset + a.perPage : a.itemsEnd), p = r(() => {
      let e = a.page;
      return P(a.offset) && (e = Math.max(Math.ceil((d.value ?? 1) / a.perPage), 1)), e < a.firstPage && a.count > 0 ? a.firstPage : e > n.value ? n.value : e;
    });
    return (e, t) => {
      var v;
      return m(), b("div", N(l(B), {
        id: `${e.widgetId}-${e.variant}-pagination`,
        class: [
          l(s).pagination,
          l(w),
          {
            [l(s).modifiers.bottom]: e.variant === "bottom",
            [l(s).modifiers.static]: e.static,
            [l(s).modifiers.sticky]: e.sticky
          }
        ]
      }), [
        e.variant === "top" || e.$slots.total ? (m(), b("div", {
          key: 0,
          class: E(l(s).paginationTotalItems)
        }, [
          k(e.$slots, "total", {
            firstIndex: u.value,
            lastIndex: f.value,
            count: e.count,
            titleItems: e.titleItems
          }, () => [
            I("b", null, g(u.value) + " - " + g(f.value), 1),
            t[6] || (t[6] = L(" of ")),
            I("b", null, g(e.count), 1),
            L(" " + g(e.titleItems), 1)
          ])
        ], 2)) : c("", !0),
        ((v = e.perPageOptions) == null ? void 0 : v.length) > 0 ? (m(), O(G, {
          key: 1,
          "items-per-page-title": e.titleItemsPerPage,
          "per-page-suffix": e.titlePerPageSuffix,
          "items-title": e.compact ? "" : e.titleItems,
          "options-toggle": e.titleOptionsToggle,
          "per-page-options": e.perPageOptions,
          "first-index": d.value ?? u.value,
          "last-index": C.value ?? f.value,
          "last-full-page-shown": e.lastFullPageShown,
          count: e.count,
          "drop-up": e.dropUp,
          "widget-id": `${e.widgetId}-${e.variant}`,
          disabled: e.disabled,
          page: p.value,
          "per-page": e.perPage,
          "onUpdate:perPage": t[0] || (t[0] = (i) => o("update:perPage", i))
        }, null, 8, ["items-per-page-title", "per-page-suffix", "items-title", "options-toggle", "per-page-options", "first-index", "last-index", "last-full-page-shown", "count", "drop-up", "widget-id", "disabled", "page", "per-page"])) : c("", !0),
        F(M, {
          "pages-title": e.titlePage,
          "pages-title-plural": e.titlePages,
          "to-last-page-aria-label": e.toLastPageAriaLabel,
          "to-previous-page-aria-label": e.toPreviousPageAriaLabel,
          "to-next-page-aria-label": e.toNextPageAriaLabel,
          "to-first-page-aria-label": e.toFirstPageAriaLabel,
          "curr-page-aria-label": e.currPageAriaLabel,
          "pagination-aria-label": e.paginationAriaLabel,
          page: e.count <= 0 ? 0 : p.value,
          "per-page": e.perPage,
          "first-page": d.value ?? 1,
          "last-page": n.value,
          disabled: e.disabled,
          compact: e.compact,
          onSetPage: t[1] || (t[1] = (i) => o("update:page", i)),
          onFirstClick: t[2] || (t[2] = (i) => o("first-click", i)),
          onPreviousClick: t[3] || (t[3] = (i) => o("previous-click", i)),
          onNextClick: t[4] || (t[4] = (i) => o("next-click", i)),
          onLastClick: t[5] || (t[5] = (i) => o("last-click", i))
        }, null, 8, ["pages-title", "pages-title-plural", "to-last-page-aria-label", "to-previous-page-aria-label", "to-next-page-aria-label", "to-first-page-aria-label", "curr-page-aria-label", "pagination-aria-label", "page", "per-page", "first-page", "last-page", "disabled", "compact"]),
        k(e.$slots, "default")
      ], 16, V);
    };
  }
});
export {
  Q as default
};
